<template>
  <div
    class="has-background-white is-border"
    style="position: relative;"
    v-if="sale">
    <div
      v-if="adv.status==='canceled' || !plan.adv_enabled || !adv.promoteur.plan.adv_enabled"
      class="frontdrop"></div>
    <div
      class="is-padding-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall is-minH50p is-flex">
      <div class="is-self-centered">
        <span class="is-uppercase title is-6">Notaire(s)</span>
      </div>
    </div>
    <div
      class="columns is-12 is-gapless is-padding-left is-padding-right-small is-vcentered is-minH50p is-marginless-bottom"
      :class="!sale.notary_data.has_procuration ? 'is-border-top has-background-white--darken1 ' : 'has-background-dark'">
      <div class="column is-narrow">
        <div class="is-padding-top-xsmall is-padding-bottom-xsmall">
          <div>
            <input
              id="has_procuration"
              v-model="sale.notary_data.has_procuration"
              name="has_procuration"
              :disabled="!(isAdmin && isPromoteur)"
              class="switch is-success is-rounded"
              type="checkbox"
              @input="sale.notary_data.has_procuration = !sale.notary_data.has_procuration">
            <label
              for="has_procuration"
              :class="!sale.notary_data.has_procuration ? '' : 'has-text-white'"
              class="is-uppercase is-size-6">
              Procuration
            </label>
          </div>
        </div>
      </div>
    </div>
    <div
      class="columns is-gapless has-background-light is-marginless is-padding-left-small is-padding-right-small is-padding-top-large is-padding-bottom-large">
      <div
        class="column is-4 is-padding-right-xsmall is-padding-left-xsmall"
        :class="{'has-content-disabled': !(isAdmin && isPromoteur)}">
        <date-picker
          :model="sale.notary_data.procuration_signee_le"
          @input="$store.commit('modifyCurrentSale', { key: `notary_data.procuration_signee_le`, value: $event })"
          class="is-self-centered"
          :field-class="'is-margin-left-xxsmall is-margin-right-xsmall is-self-centered'"
          :input-class="'is-fullwidth'"
          :style-version="2"
          label="DATE D’ENVOI POSTAL DU COURRIER"></date-picker>
      </div>
      <div class="column is-4 is-padding-right-xsmall is-padding-left-xsmall">
        <r-label
          :label="'Numéro A/R'"
          :is-required="false"
          :value="sale.notary_data.procuration_numero_ar"></r-label>
        <div
          class="field has-addons"
          :class="{'has-content-disabled': !(isAdmin && isPromoteur)}">
          <div class="control">
            <a class="button is-static is-border is-square">
              <span class="icon"><i class="far fa-mail-bulk"></i></span>
            </a>
          </div>
          <div class="control is-expanded has-icons-right">
            <v-input
              id="ref"
              name="ref"
              @input="value => $store.commit('modifyCurrentSale', { key: `notary_data.procuration_numero_ar`, value })"
              :model="sale.notary_data.procuration_numero_ar"
              v-validate="'min:1'"
              :errors-bag="errors"
              data-vv-value-path="val"
              data-vv-as="numero a/r"
              data-type-cy="input"
              data-value-cy="input_ref">
            </v-input>
          </div>
          <div class="control">
            <a
              class="button is-grey is-inverted is-border is-square"
              :disabled="!(isAdmin && isPromoteur)"
              @click="$store.commit('modifyCurrentSale', { key: `notary_data.procuration_numero_ar`, value: null })">
              <i class="fas fa-times"></i>
            </a>
          </div>
        </div>
      </div>
      <div
        class="column is-4 s-padding-right-xsmall is-padding-left-xsmall"
        :class="{'has-content-disabled': !(isAdmin && isPromoteur)}">
        <date-picker
          :model="sale.notary_data.procuration_accuse_ar"
          @input="$store.commit('modifyCurrentSale', { key: `notary_data.procuration_accuse_ar`, value: $event })"
          class="is-self-centered"
          :field-class="'is-margin-left-xxsmall is-margin-right-xsmall is-self-centered'"
          :input-class="'is-fullwidth'"
          :style-version="2"
          label="DATE DE RÉCEPTION a/r"></date-picker>
      </div>
    </div>
    <template v-for="(notaire, idx) in sale.notary_data.notaires">
      <notaire-item
        :key="idx"
        :idx="idx"
        :can-edit="isAdmin && isPromoteur"
        :source-notaire="notaire"
        @removeNotaire="removeNotaire"
        @editNotaire="editNotaire"></notaire-item>
    </template>
    <div
      v-if="isAdmin && isPromoteur"
      class="row-width-actions-bar">
      <button
        class="page-header-btn button is-dark is-fullwidth is-radiusless"
        @click="addNotaire(null)">
        <span>Ajouter un notaire en concours</span>
      </button>
    </div>

    <div class="is-padding">
      <div
        class="columns is-marginless-bottom"
        :class="{'has-content-disabled': !((isAdmin && isPromoteur) || (currentUser.active_all_contact))}">
        <div class="column is-narrow">
          <div class="field">
            <label class="label is-uppercase is-size-7">Rendez-vous notaire</label>
            <div class="control is-margin-top">
              <input
                id="notary_rdv"
                v-model="sale.notary_rdv"
                name="notary_rdv"
                class="switch is-success is-rounded"
                type="checkbox"
                :disabled="!(isAdmin && isPromoteur)">
              <label
                v-if="!sale.notary_rdv"
                for="notary_rdv">Non</label>
              <label
                v-else
                for="notary_rdv">Oui</label>
            </div>
          </div>
        </div>
        <div class="column">
          <date-picker
            :disabled="!((isAdmin && isPromoteur) || (currentUser.active_all_contact))"
            :model="sale.sale_data.expected_sign"
            @input="$store.commit('modifyCurrentSale', { key: `sale_data.expected_sign`, value: $event })"
            class="is-self-centered"
            :field-class="'is-self-centered'"
            :input-class="'is-fullwidth'"
            :style-version="2"
            label="DATE SIGNATURE PRÉVUE"></date-picker>
        </div>
        <div class="column">
          <date-picker
            ref="saleDatePicker"
            :disabled="!(isAdmin && isPromoteur)"
            :model="adv.sale_date"
            @input="onSaleDateInput($event)"
            class="is-self-centered"
            :field-class="'is-self-centered'"
            :input-class="'is-fullwidth'"
            :style-version="2"
            label="DATE DE SIGNATURE DE L'ACTE"></date-picker>
        </div>
        <div class="column">
          <date-picker
            :disabled="!(isAdmin && isPromoteur)"
            :model="adv.sale_imputation_date"
            @input="$store.commit('modifyCurrentSale', { key: `sale_imputation_date`, value: $event, patch: true })"
            class="is-self-centered"
            :field-class="'is-self-centered'"
            :input-class="'is-fullwidth'"
            :style-version="2"
            label="DATE D'IMPUTATION ACTE"></date-picker>
        </div>
      </div>
    </div>
    <div
      class="is-border-top columns is-12 is-gapless is-marginless-bottom is-padding-left is-padding-right is-vcentered is-minH50p"
      :class="!sale.notary_data.free_notary_fees ? 'has-background-white--darken1 ' : 'has-background-dark'">
      <div class="column is-narrow">
        <div class="is-padding-top-xsmall is-padding-bottom-xsmall">
          <div>
            <input
              id="free_notaire"
              v-model="sale.notary_data.free_notary_fees"
              name="free_notaire"
              class="switch is-success is-rounded"
              type="checkbox"
              :disabled="!(isAdmin && isPromoteur)">
            <label
              for="free_notaire"
              :class="!sale.notary_data.free_notary_fees ? '' : 'has-text-white'"
              class="is-uppercase is-size-6">
              Frais de notaire offerts
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="is-padding">
      <div
        class="column is-4"
        v-if="!sale.notary_data.free_notary_fees">
        <r-label
          :label="'frais de notaire'"
          :value="sale.sale_data.notary_fees"
          :is-required="false"></r-label>
        <div class="field has-addons">
          <div class="control">
            <a class="button is-static is-border is-square">
              <span class="icon"><i class="fas fa-euro-sign"></i></span>
            </a>
          </div>
          <div class="control is-expanded">
            <v-input
              :disabled="!(isAdmin && isPromoteur)"
              id="notary_fees"
              name="notary_fees"
              :model="sale.sale_data.notary_fees"
              class=""
              @input="value => $store.commit('modifyCurrentSale', { key: `sale_data.notary_fees`, value })"
              v-validate="'decimal:2'"
              :errors-bag="errors"
              data-vv-value-path="val"
              :number="true"
              input-type="number"
              :three-space="true"
              data-vv-as="frais de notaire">
            </v-input>
          </div>
        </div>
      </div>
    </div>

    <div
      id="document-list-item"
      class="is-margin-bottom is-margin-right is-margin-left is-border-bottom is-border-left is-border-right">
      <div class="is-border-top">
        <document-list-item
          v-for="(doc, idx) in sale.notary_data.documents"
          :source="doc"
          :key="idx + '-document'"
          :index="idx"
          :can-drag="false"
          :open-input="true"
          :selected-row="selectedRow"
          @selectedRow="val => selectedRow = val"
          @update="updateDoc"
          @remove="removeContratDocument">
        </document-list-item>
      </div>
      <div class="row-width-actions-bar">
        <button
          class="page-header-btn is-dark is-fullwidth is-radiusless"
          :disabled="!(isAdmin && isPromoteur)"
          @click="addDocument">
          <span :class="{'has-text-grey' : !(isAdmin && isPromoteur)}">Ajouter un document à la liste</span>
        </button>
      </div>
    </div>
    <div
      v-if="isAdmin && isPromoteur || currentUser.active_all_contact"
      class="has-background-white is-border-top">
      <div class="row-width-actions-bar columns is-gapless is-marginless">
        <div class="column is-self-centered is-padding-left is-padding-top-xsmall is-padding-bottom-xsmall">
          <span class="is-uppercase title is-6">Commentaire</span>
        </div>
        <div class="column is-narrow is-border-left">
        </div>
      </div>
      <template v-if="openComment">
        <div
          v-if="!openCommentWysi && comment"
          @click="openWysiwyg"
          class="vadDiscussion is-border-top"
          style="cursor: pointer;">
          <div
            class="vadDiscussion--bulle is-size-6 is-minH50p vadDiscussion--bulle--has-actions is-cut is-padding-left">
            <div
              class="content"
              v-if="(isAdmin || currentUser.active_all_contact) && comment"
              v-html="comment"></div>
            <div class="actionsOnRow actionsOnRow--vertical">
              <div class="">
                <button
                  @click="openWysiwyg"
                  class="is-min-height-full">
                  <span class="icon is-small"><i class="fal fa-edit"></i></span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else
          class="is-border-top columns is-gapless">
          <div class="column">
            <wysiwyg-editor
              :light="true"
              :tooltip-top="true"
              :model="comment"
              @change="val => comment = val"
              class="editr--bottom-toolbar no-toolbar editr--height-small content is-borderless">
            </wysiwyg-editor>
          </div>
          <div class="actionsOnRow actionsOnRow--vertical">
            <div>
              <button
                @click="patchComment()"
                type="button"
                class="button"
                :class="[(baseComment !== comment) ? 'is-success' : 'is-info']"
                :disabled="(baseComment === comment)">
                <span class="icon is-small">
                  <i
                    v-if="loadComment"
                    class="fas fa-spinner fa-spin"></i>
                  <i
                    v-else
                    class="fal fa-save"></i>
                </span>
              </button>
            </div>
            <div class="">
              <button
                :disabled="!baseComment"
                type="button"
                :class="{'actionsOnRow-btn--hoverIsDanger': comment}"
                @click="comment?openCommentWysi = false:null; comment = baseComment">
                <span class="icon is-small"><i class="fal fa-times"></i></span>
              </button>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { Adv } from '@/mixins'
export default {
  name: 'Notaire',
  components: {
    DocumentListItem: () => import('../DocumentListItem'),
    NotaireItem: () => import('./NotaireItem')
  },
  mixins: [Adv],
  data () {
    return {
      selectedRow: null
    }
  },
  watch: {
    'sale.notary_data.free_notary_fees' (to) {
      this.$store.commit('modifyCurrentSale', { key: `notary_data.free_notary_fees`, value: to })
    },
    'sale.notary_data.has_procuration' (to) {
      this.$store.commit('modifyCurrentSale', { key: `sale_data.has_procuration`, value: to })
    },
    'sale.notary_rdv' (to) {
      this.$store.commit('modifyCurrentSale', { key: `notary_rdv`, value: to })
    }
  },
  methods: {
    /**
      * ask a confirmation before setting the sale date, which switches the adv to "actée"
      * @param {string} value - iso date or null
      */
    async onSaleDateInput (value) {
      // le commit remet à jour adv.sale_date, ce qui fait ré-émettre le picker : on ignore ce second passage
      if (value && this.adv.sale_date && moment(value).isSame(this.adv.sale_date)) return
      if (value) {
        const { dismiss } = await this.confirmSaleDate()
        // swal rend le focus au champ date en se fermant, ce qui rouvre flatpickr :
        // on referme et on blur après coup, quel que soit le bouton cliqué
        setTimeout(() => {
          const fp = this.$refs.saleDatePicker.$refs.flatpickr.fp
          fp.close()
          const input = fp.altInput || fp.input
          if (input) input.blur()
        }, 100)
        if (dismiss) {
          // the picker keeps its own copy of the date, reset it to the adv value
          this.$refs.saleDatePicker.initDateModel()
          return
        }
      }
      this.$store.commit('modifyCurrentSale', { key: `sale_date`, value, patch: true })
    },
    /**
      * remove contrat document
      */
    removeContratDocument (idx) {
      this.sale.notary_data.documents.splice(idx, 1)
      this.$store.commit('modifyCurrentSale', { key: `notary_data.documents`, value: this.sale.notary_data.documents })
    },
    /**
      * update doc
      */
    updateDoc (doc) {
      this.$toasted.global.success('Le document à été téléchargé avec succès')
      this.$store.commit('modifyCurrentSale', { key: `notary_data.documents`, value: this.sale.notary_data.documents })
    },
    /**
      * add notaire
      * @param {string} label
      * @param {boolean} save
      */
    addNotaire (label = null, save = true) {
      // let count = (this.notaires.length + 1) - 2
      if (!label) {
        label = 'Notaire en concours'
      }
      this.sale.notary_data.notaires.push({
        label,
        email: null,
        address: null,
        name: null,
        phone: null
      })
      this.$store.commit('modifyCurrentSale', { key: `notary_data.notaires`, value: this.sale.notary_data.notaires })
    },
    /**
      * remove notaire
      * @param {number} index
      */
    removeNotaire (index) {
      this.sale.notary_data.notaires.splice(index, 1)
      this.$store.commit('modifyCurrentSale', { key: `notary_data.notaires`, value: this.sale.notary_data.notaires })
    },
    /**
      * edit notaire
      * @param {number} idx
      * @param {object} notaire
      */
    editNotaire ({ idx, notaire }) {
      let updatedNotaire = this.sale.notary_data.notaires
      updatedNotaire.splice(idx, 1, notaire)
      this.$set(this.sale.notary_data, 'notaires', updatedNotaire)
      this.$store.commit('modifyCurrentSale', { key: `notary_data.notaires`, value: this.sale.notary_data.notaires })
    },
    /**
      * add document
      * @param {object} item
      */
    addDocument (item = {}) {
      this.sale.notary_data.documents.push({
        name: item.name || `Nouveau Document ${this.sale.notary_data.documents.length + 1}`,
        value: item.name || `new_document_${this.sale.notary_data.documents.length + 1}`,
        document: item.document || null
      })
      this.$store.commit('modifyCurrentSale', { key: `notary_data.documents`, value: this.sale.notary_data.documents })
    }
  }
}
</script>
